import styled from "styled-components";

export const GameTitle = styled.div`
  background-color: #1517ac;
  margin-bottom: 15px;
  color: white;
  height: 30px;
  padding: 0 10px;
  align-items: center;
  display: flex;
  font-weight: 600;
  font-size: 17px;

  @media (max-width: 820px) {
    display: none;
  }
`;

export const GameDescription = styled.p`
  color: black;
  margin: 0px 0 10px 2px;
  font-size: 17.5px;
  font-weight: 500;
  font-style: normal;
  line-height: 1.18;
  text-align: right;

  @media (max-width: 820px) {
    display: none;
  }
`;
